import { NavLink } from 'react-router-dom';
import { LogOut, Inbox, FileText, Mail, Settings, Users } from 'lucide-react';
import clsx from 'clsx';
import { useAuth } from '../hooks/useAuth';

export default function Header() {
  const { user, isAdmin, logout } = useAuth();

  const navClass = ({ isActive }: { isActive: boolean }) =>
    clsx(
      'inline-flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors',
      isActive ? 'bg-teal-light text-teal' : 'text-gray-600 hover:bg-teal-light hover:text-teal',
    );

  return (
    <header className="sticky top-0 z-20 border-b border-gray-200 bg-white/95 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-7xl items-center gap-6 px-6">
        <NavLink to="/" className="flex items-center gap-3">
          <img src="/bd-color.svg" alt="BuyDubai" className="h-7 w-auto" />
          <span className="hidden font-heading text-lg font-semibold text-dark sm:block">
            LeadHub
          </span>
        </NavLink>

        <nav className="flex items-center gap-1">
          <NavLink to="/" end className={navClass}>
            <Inbox size={16} /> Leady
          </NavLink>
          <NavLink to="/pages" className={navClass}>
            <FileText size={16} /> Stránky a formuláře
          </NavLink>
          <NavLink to="/templates" className={navClass}>
            <Mail size={16} /> Šablony
          </NavLink>
          {isAdmin && (
            <>
              <NavLink to="/settings" className={navClass}>
                <Settings size={16} /> Nastavení
              </NavLink>
              <NavLink to="/users" className={navClass}>
                <Users size={16} /> Uživatelé
              </NavLink>
            </>
          )}
        </nav>

        <div className="ml-auto flex items-center gap-3">
          <span className="hidden text-sm text-gray-600 md:block">{user?.name}</span>
          <button onClick={logout} className="btn-ghost" title="Odhlásit se">
            <LogOut size={16} />
          </button>
        </div>
      </div>
    </header>
  );
}
